import { Box, Button, H1, IconButton, PancakeStack, Text, WorkflowHeader } from '@betterment/samba-react';
import { useParams } from 'react-router-dom';

import { SupportEmail } from '../../Shared/Components/SupportEmail';
import urlBuilder from '../../Shared/url-builder';
import { navigate } from '../../utils/path-helpers';
import { FirmLogo } from '../FirmLogo';

export const OtherSpouseParticipant = () => {
  const { householdId } = useParams<{ householdId: string }>();

  // @ts-expect-error TS2345 violates strict null checks
  const navigateBackToHouseHold = () => navigate(urlBuilder.getHouseholdsPage(householdId));

  return (
    <PancakeStack css={{ maxWidth: '100%' }}>
      <Box css={{ borderBottom: '1px solid', borderColor: 'border' }}>
        <WorkflowHeader css={{ width: '100%', maxWidth: '1200px', justifySelf: 'center' }}>
          <WorkflowHeader.Leading css={{ px: 'space.400' }}>
            <FirmLogo />
          </WorkflowHeader.Leading>
          <WorkflowHeader.Title css={{ px: 'space.400' }}>Add spouse participant</WorkflowHeader.Title>
          <WorkflowHeader.Trailing css={{ px: 'space.400' }}>
            <IconButton label="back to household" name="X" spacing="compact" onClick={navigateBackToHouseHold} />
          </WorkflowHeader.Trailing>
        </WorkflowHeader>
      </Box>
      <PancakeStack.Main>
        <Box
          css={{
            justifySelf: 'center',
            maxWidth: '584px',
            mt: 'space.600',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box css={{ mb: 'space.200' }}>
            <H1 variant="title400">Please contact our support team.</H1>
          </Box>
          <Box css={{ mb: 'space.400' }}>
            <Text variant="text100">
              To add a new member outside the existing household as a spouse participant to a Solo 401(k) plan, contact
              us at
              <SupportEmail />
            </Text>
          </Box>
          <Box>
            <Button onClick={navigateBackToHouseHold}>Close</Button>
          </Box>
        </Box>
      </PancakeStack.Main>
    </PancakeStack>
  );
};
